import OperationBatchStatus from "@wallet-manager/node-types/dist/types/postgres/const/OperationBatchStatus";

export const checkIsResubmitBtnDisabled = (status: number) => {
  return !(
    status === OperationBatchStatus.SubmitFailed ||
    status === OperationBatchStatus.Requested
  );
};
